import React from 'react';
import 'components/canvas/components/canvas-loader/style.css';
import { Loader } from './styled';
import useCanvasLoading from 'components/canvas/hooks/use-canvas-loading';

function CanvasLoader() {
  const { isLoading } = useCanvasLoading();

  if (isLoading) {
    return (
      <Loader
        animation={'wave'}
        variant="rect"
        width={'100%'}
        height={'100vh'}
      />
    );
  }

  return null;
}

CanvasLoader.defaultProps = {};

export default CanvasLoader;
